import axios from "axios";
import * as types from "../mutation-types";
import api from "@/api/api";

export const state = {
  timeSheets: [],
  timeSheetRequests: [],
  timeSheet: {},
  timeSheetToday: {
    start_time_real: true,
    end_time_real: true
  },
  timeSheetsExport: [],
  pagination: {
    from: 0,
    to: 0,
    totalPage: 0,
    path: "",
    currentPage: 0,
    totalRecord: 0,
    perPage: 0
  },
  timesheetDashboard: {
    checkSubmitted: false,
    dayWorking: 0,
    dayWorkingReal: 0,
    missTimesheet: 0,
    normalDayWorking: 0,
    overtimeRequestTotal: 0,
    sabbaticalLeave: 0,
    totalCompensation: 0,
    unpaidLeave: 0,
  },
  timesheetTotalRequest: {
    totalOTRequestStatus: {
      "1": 0,
      "2": 0,
      "3": 0
    },
    totalTimesheetRequestStatus: {
      "1": 0,
      "2": 0,
      "3": 0
    },
    totalSabbaticalRequestStatus: {
      "1": 0,
      "2": 0,
      "3": 0
    },
    totalRemoteRequestStatus: {
      "1": 0,
      "2": 0,
      "3": 0
    }
  }
};

// getters
export const getters = {
  timeSheets: state => state.timeSheets,
  timeSheet: state => state.timeSheet,
  timeSheetRequests: state => state.timeSheetRequests,
  pagination: state => state.pagination,
  timeSheetToday: state => state.timeSheetToday,
  timeSheetsExport: state => state.timeSheetsExport,
  timesheetDashboard: state => state.timesheetDashboard,
  timesheetTotalRequest: state => state.timesheetTotalRequest
};

// mutations
export const mutations = {
  [types.TIMESHEET.FETCH_TIMESHEET](state, timeSheets) {
    state.timeSheets = timeSheets;
    state.pagination.from = timeSheets.from;
    state.pagination.to = timeSheets.to;
    state.pagination.totalPage = timeSheets.last_page;
    state.pagination.path = timeSheets.path;
    state.pagination.currentPage = timeSheets.current_page;
    state.pagination.totalRecord = timeSheets.total;
    state.pagination.perPage = timeSheets.per_page;
  },
  [types.TIMESHEET.DETAIL_timesheet](state, timeSheet) {
    state.timeSheet = timeSheet;
  },
  [types.TIMESHEET.FETCH_TIMESHEET_REQUEST](state, timeSheetRequests) {
    state.timeSheetRequests = timeSheetRequests;
    state.pagination.from = timeSheetRequests.from;
    state.pagination.to = timeSheetRequests.to;
    state.pagination.totalPage = timeSheetRequests.last_page;
    state.pagination.path = timeSheetRequests.path;
    state.pagination.currentPage = timeSheetRequests.current_page;
    state.pagination.totalRecord = timeSheetRequests.total;
    state.pagination.perPage = timeSheetRequests.per_page;
  },
  [types.TIMESHEET.FETCH_TIMESHEET_TODAY](state, timeSheet) {
    state.timeSheetToday = timeSheet;
  },
  [types.TIMESHEET.FETCH_TIMESHEET_EXPORT](state, timeSheetsExport) {
    state.timeSheetsExport = timeSheetsExport;
  },
  [types.TIMESHEET.FETCH_TIMESHEET_DASHBOARD](state, data) {
    state.timesheetDashboard = data;
  },
  [types.TIMESHEET.FETCH_TIMESHEET_TOTAL_REQUEST](state, data) {
    state.timesheetTotalRequest.totalOTRequestStatus = data.totalOTRequestStatus;
    state.timesheetTotalRequest.totalTimesheetRequestStatus = data.totalTimesheetRequestStatus;
    state.timesheetTotalRequest.totalSabbaticalRequestStatus = data.totalSabbaticalRequestStatus;
    state.timesheetTotalRequest.totalRemoteRequestStatus = data.totalRemoteRequestStatus;
  }
};

// actions
export const actions = {
  async fetchTimeSheet({
    commit
  }, payload) {
    const response = await axios.get(api.TIME_SHEET, {
      params: {
        per_page: payload.itemsPerPage,
        page: payload.currentPage,
        start_date: payload.start_date,
        end_date: payload.end_date,
        company_code: payload.company_code,
        foot_code: payload.foot_code,
        division_code: payload.division_code,
        employee_info: payload.employee_info
      }
    });
    commit(types.TIMESHEET.FETCH_TIMESHEET, response.data.timeSheets);
  },
  async fetchUserTimeSheet({
    commit
  }, payload) {
    // console.log(payload);
    const response = await axios.get(api.USER_TIME_SHEET, {
      params: {
        // per_page: payload.itemsPerPage,
        // page: payload.currentPage,
        // start_date: payload.start_date,
        // end_date: payload.end_date,
        month: payload.month,
        sort_column: payload.sortColumn,
        sort_by: payload.sortBy
      }
    });
    commit(types.TIMESHEET.FETCH_TIMESHEET, response.data.timeSheets);
  },
  async checkIn() {
    await axios.post(api.USER_CHECK_IN);
  },
  async checkOut() {
    await axios.post(api.USER_CHECK_OUT);
  },
  async fetchTimeSheetRequest({
    commit
  }, payload) {
    const response = await axios.get(api.TIME_SHEET_REQUEST, {
      params: {
        per_page: payload.itemsPerPage,
        page: payload.currentPage,
        start_date: payload.start_date,
        end_date: payload.end_date,
        company_code: payload.company_code,
        foot_code: payload.foot_code,
        division_code: payload.division_code,
        employee_info: payload.employee_info,
        status: payload.status
      }
    });
    commit(
      types.TIMESHEET.FETCH_TIMESHEET_REQUEST,
      response.data.timeSheetRequests
    );
  },
  async fetchTimeSheetToday({
    commit
  }) {
    const response = await axios.get(api.TIME_SHEET_TODAY);
    commit(types.TIMESHEET.FETCH_TIMESHEET_TODAY, response.data.timeSheet);
  },
  // eslint-disable-next-line
  async updateTimeSheet({}, data) {
    let url = `${api.TIME_SHEET}/${data.id}`;
    await axios.put(url, data).then(res => res);
  },
  // eslint-disable-next-line
  async importTimesheet({}, payload) {
    await axios.post(api.IMPORT_TIMESHEET, {
      data: payload.data
    });
  },
  async fetchTimeSheetsExport({
    commit
  }, payload) {
    const response = await axios.get(api.TIME_SHEET, {
      params: {
        per_page: payload.itemsPerPage,
        page: payload.currentPage,
        start_date: payload.start_date,
        end_date: payload.end_date,
        company_code: payload.company_code,
        foot_code: payload.foot_code,
        division_code: payload.division_code,
        employee_info: payload.employee_info,
        export: payload.export
      }
    });
    commit(types.TIMESHEET.FETCH_TIMESHEET_EXPORT, response.data.timeSheets);
  },
  async fetchTimesheetDashboard({
    commit
  }, payload) {
    const response = await axios.get(api.TIMESHEET_DASHBOARD, {
      params: {
        month: payload.month,
      }
    });
    commit(types.TIMESHEET.FETCH_TIMESHEET_DASHBOARD, response.data);
  },
  async fetchTimesheetTotalRequest({
    commit
  }, payload) {
    const response = await axios.get(api.TIMESHEET_TOTAL_REQUEST, {
      params: {
        month: payload.month,
      }
    });
    commit(types.TIMESHEET.FETCH_TIMESHEET_TOTAL_REQUEST, response.data);
  },
  async compensationTimesheet( _ , params) {
    await axios.post(api.COMPENSATION_TIMESHEET, params);
  },
  async submitTimesheet( _ , params) {
    await axios.post(api.SUBMIT_TIMESHEET, params);
  },
  async unsubmitTimesheet( _ , params) {
    await axios.post(api.UNSUBMIT_TIMESHEET, params);
  },
};
